/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum FreightClaimCondition {
  New = "new_",
  Used = "used",
}

export function instanceOfFreightClaimCondition(value: any): boolean {
  for (const key in FreightClaimCondition) {
    if (Object.prototype.hasOwnProperty.call(FreightClaimCondition, key)) {
      if (
        FreightClaimCondition[key as keyof typeof FreightClaimCondition] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function FreightClaimConditionFromJSON(
  json: any,
): FreightClaimCondition {
  return FreightClaimConditionFromJSONTyped(json, false);
}

export function FreightClaimConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FreightClaimCondition {
  return json as FreightClaimCondition;
}

export function FreightClaimConditionToJSON(
  value?: FreightClaimCondition | null,
): any {
  return value as any;
}

export function FreightClaimConditionToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): FreightClaimCondition {
  return value as FreightClaimCondition;
}
